'use strict';
/**
 *
 * Usage:
 *
 *   data-sw-typeahead
 *
 *   place on a text area that should be able to give suggestions
 *
 *
 *   data-sw-typeahead-users
 *
 *   detect and suggest @ mentions of usernames
 *
 *   if you want to pre-load a set of users, make sure to add them to sw.data.user[USERS_PRELOAD]
 *   eg. a user's Followers and people they Follow
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var _ = require('underscore');

var typeahead_user_suggestion_tpl = require('rrTags/user/templates/tpl.user-typeahead-suggestion.mustache');
var typeahead_user_mention_tpl = require('rrTags/user/templates/tpl.user-mention.mustache');


var ROOT_NAME = 'swTypeahead';
var USER_TYPE = 'users';
var USERS_PRELOAD = 'typeaheadFollowersAndLeaders';

var TAG_REGEX = /\$\{([^\}]*)\}/g;

var userConfig = {
  at: '@',
  callbacks: {
    remoteFilter: _.debounce(function(query, callback) {
      if(query.length > 1) {
        $.swAjax({
          dataType: 'json',
          url: '/user/search/dropdown',
          data: {q: query},
          success: function(data) {
            callback(data);
          }
        });
      }
    }, 600),
    tplEval : function(tpl, map) {
      var error, template;
      template = tpl;
      try {
        if (_.isFunction(tpl)) {
          template = tpl(map);
        }
        //original behaviour
        if (typeof tpl === 'string') {
          return template.replace(TAG_REGEX, function (tag, key) {
            return map[key];
          });
        }
        //otherwise it's a hogan template
        return template.render(map);
      } catch (error1) {
        error = error1;
        return "";
      }
    },
    highlighter: function (li, query) {
      var regexp;
      if (!query) {
        return li;
      }
      //include 'at' symbol to allow for it in suggestions while still supporting highlighting
      regexp = new RegExp(">\\s*([\\w@]*?)(" + query.replace("+", "\\+") + ")([\\w@]*)\\s*<", 'ig');
      return li.replace(regexp, function (str, $1, $2, $3) {
        return '> ' + $1 + '<strong>' + $2 + '</strong>' + $3 + ' <';
      });
    }
  },
  displayTpl: typeahead_user_suggestion_tpl,
  insertTpl: typeahead_user_mention_tpl,
  searchKey: 'username',
  limit: 5
};

function buildTypeahead($fragment) {
  $fragment.swFindWithSelf('[data-sw-typeahead]').each(function() {
    var $el = $(this);
    var settings = $el.swDataParams(ROOT_NAME, {excludePrefix: true});
    var usersPreload = sw.data.user ? sw.data.user[USERS_PRELOAD] : {};

    if(settings.hasOwnProperty(USER_TYPE)) {
      if(usersPreload) {
        userConfig.data = usersPreload;
      }
      $el.atwho(userConfig);
    }
  });
}

module.exports = function($fragment) {
  if ($.fn.atwho) {
    buildTypeahead($fragment);
  } else {
    require(['js/sw-jquery/vendor/jquery.atwho'], function(atWhoPlugin) {
      atWhoPlugin($);

      buildTypeahead($fragment);
    });
  }
};
